<template>
    <div class="doughnut-chart-wrapper">
        <div
            id="chartjs-tooltip"
            ref="tooltip"
            :style="tooltipStyles"
        >
            {{ tooltipContent }}
        </div>
        <canvas ref="doughnut" class="doughnut-chart" />
        <div
            class="title large-size"
            v-html="`${title}<span class='small-size'>Mediennutzung</span>`"
        />
    </div>
</template>

<script>
import {Chart, ArcElement, DoughnutController, Tooltip} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ArcElement, DoughnutController, Tooltip, ChartDataLabels);

export default {
    name: 'DoughnutChart',
    props: {
        totalTime: {
            type: Number,
            default: 0
        },
        data: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        title: '',
        tooltipContent: '',
        tooltipStyles: {}
    }),
    mounted()
    {
        const {doughnut} = this.$refs;

        this.chart = new Chart(
            doughnut,
            {
                plugins: [ChartDataLabels],
                type: 'doughnut',
                data: this.data,
                options: {
                    cutout: '75%',
                    elements: {
                        arc: {
                            borderWidth: 2
                        },
                        bar: {
                            borderWidth: 4
                        }
                    },
                    plugins: {
                        datalabels: {
                            formatter: value => ((value > 0) ? value : ''),
                            clip: true,
                            color(context)
                            {
                                const index = context.dataIndex;
                                const value = context.dataset.data[index];
                                return value > 10 ? '#ffffff' : '#000000';
                            },
                            font: {
                                family: 'Merriweather Sans',
                                size: 18
                            }
                        },
                        tooltip: {
                            enabled: false,
                            external: this.externalTooltipHandler,
                            callbacks: {
                                label(context)
                                {
                                    return context.label;
                                }
                            }
                        }
                    }
                }
            }
        );

        this.title = this.getTimeFromSliderValue(this.totalTime);
    },
    destroyed()
    {
        this.chart.destroy();
    },
    methods: {
        getTimeFromSliderValue(value)
        {
            let hours = 0;
            let minutes = 0;

            const tempValue = value / 60;
            hours = Math.floor(tempValue);
            minutes = Math.round((tempValue - hours) * 60);

            if (hours === 0 && minutes === 0)
            {
                return 'keine';
            }

            hours = (hours < 10) ? `0${hours}` : hours;

            return `${hours} Stunden<br>${minutes} Minuten`;
        },
        externalTooltipHandler(context)
        {
            const tooltipModel = context.tooltip;

            if (tooltipModel.opacity === 0)
            {
                this.tooltipStyles.opacity = 0;
                return;
            }

            if (tooltipModel.body)
            {
                const [title] = tooltipModel.body[0].lines;
                this.tooltipContent = title;
            }

            this.tooltipStyles = {
                opacity: 1,
                position: 'absolute',
                left: `${tooltipModel.caretX + 55}px`,
                top: `${tooltipModel.caretY + 5}px`
            };
        }
    }
};
</script>

<style lang="scss" src="./DoughnutChart.scss" />
